import React from 'react';
import { Button } from './ui/Button';
import { CountdownTimer } from './CountdownTimer';
import { ShieldCheck, Lock, CreditCard, Zap } from 'lucide-react';
export function FinalCTA() {
  return <section className="py-20 px-4 bg-brand-darker relative overflow-hidden border-t border-white/5" data-id="element-110">
      <div className="absolute bottom-0 left-1/2 -translate-x-1/2 w-[800px] h-[400px] bg-brand-gold/10 rounded-t-full blur-[100px] pointer-events-none" data-id="element-111" />

      <div className="max-w-3xl mx-auto text-center relative z-10" data-id="element-112">
        <h2 className="text-3xl md:text-5xl font-bold mb-6" data-id="element-113">
          El próximo domingo puede ser diferente. 🍳📚
        </h2>

        <CountdownTimer data-id="element-114" />

        <div className="space-y-6 mt-12" data-id="element-115">
          <div className="bg-brand-card border border-white/10 p-6 rounded-2xl flex flex-col md:flex-row items-center justify-between gap-6" data-id="element-116">
            <div className="text-left" data-id="element-117">
              <div className="font-bold text-lg" data-id="element-118">📦 PACK ¿QUÉ COMEMOS HOY?</div>
              <div className="text-gray-400 line-through text-sm" data-id="element-119">$68.000</div>
              <div className="text-2xl font-bold text-white" data-id="element-120">$17.990 ARS</div>
            </div>
            <Button variant="outline" className="w-full md:w-auto" onClick={() => window.open('https://www.bibliotecasdigitales.store/checkouts/cn/hWNB77rzlDfrnT8Rg8IdchHu/es-ar?_r=AQABVf-B6bB72M1QNGEUVofnoUoOpJD2Jn4ZxVvQ47AfyLw&cart_link_id=W58G0UCK&locale=es-AR&preview_theme_id=154123698339', '_blank')} data-id="element-121">
              <span className="mr-2" data-id="element-122">🔴</span> QUIERO MI PACK AHORA
            </Button>
          </div>

          <div className="bg-gradient-to-r from-brand-card to-brand-darker border-2 border-brand-gold p-6 rounded-2xl flex flex-col md:flex-row items-center justify-between gap-6 shadow-[0_0_20px_rgba(212,160,23,0.15)]" data-id="element-123">
            <div className="text-left" data-id="element-124">
              <div className="font-bold text-lg text-brand-gold" data-id="element-125">
                🏆 PACK COMPLETO + MÉTODO
              </div>
              <div className="text-gray-400 line-through text-sm" data-id="element-126">$90.000</div>
              <div className="text-3xl font-bold text-white" data-id="element-127">$27.990 ARS</div>
            </div>
            <Button variant="primary" className="w-full md:w-auto" onClick={() => window.open('https://www.bibliotecasdigitales.store/checkouts/cn/hWNB78QLSSrer4OVYywHZACw/es-ar?_r=AQABNhPiEa787tTn-OxeMBhcgxKUnjPjt4qe1OxU6mnkbuA&cart_link_id=wzK5MD8v&locale=es-AR&preview_theme_id=154123698339', '_blank')} data-id="element-128">
              <span className="mr-2" data-id="element-129">🔴</span> QUIERO EL PACK + AHORRO
            </Button>
          </div>
        </div>

        <div className="flex flex-wrap justify-center gap-6 text-sm text-gray-400 mt-12" data-id="element-130">
          <div className="flex items-center gap-2" data-id="element-131">
            <Lock className="w-4 h-4 text-brand-gold" data-id="element-132" /> Pago 100% seguro
          </div>
          <div className="flex items-center gap-2" data-id="element-133">
            <Zap className="w-4 h-4 text-brand-gold" data-id="element-134" /> Acceso en 5 minutos
          </div>
          <div className="flex items-center gap-2" data-id="element-135">
            <ShieldCheck className="w-4 h-4 text-brand-gold" data-id="element-136" /> Garantía 7 días
          </div>
          <div className="flex items-center gap-2" data-id="element-137">
            <CreditCard className="w-4 h-4 text-brand-gold" data-id="element-138" /> Mercado Pago |
            Tarjeta | Transferencia
          </div>
        </div>
      </div>
    </section>;
}